module.exports = __webpack_public_path__ + "img/icon180.0659054a.jpg";